import PropTypes from "prop-types";
import '../UI/styling_ui_elements.scss';
import React_select from "./React_select";
import { useEffect } from "react";

function Select_Input(props) {
  const oldDesign = false;

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    // console.groupCollapsed("field changed in: "+name)
    // console.log("to value of "+value);
    // console.groupEnd();
    props.updateSelectChange(name, value);
  };

  useEffect(() => {
  console.warn('Props updated:', {
    target: props.inputName,
    id: props.id,
    data: props.data,
    preloaded: props.optionSelectedOnLoad,
    dataType: typeof props.data,
    isArray: Array.isArray(props.data),
    length: props.data?.length
  });
}, [props.data]);

  function disableIfUsersAccessNotAllowed(){
    
    if(props.inputName === "team-filter" || props.inputName === "agent-filter" || props.inputName === "office-filter"){
      if(sessionStorage.getItem("user-accessLevel") < 4){
        if(props.inputName === "agent-filter" && (Number(sessionStorage.getItem("is_leader")) !== 0 || sessionStorage.getItem("user-accessLevel") >= 3)){
          return false
        }else if(props.inputName === "team-filter" && sessionStorage.getItem("user-accessLevel") >= 3){
          return false
        }else{
          return true;
        }
       }else{
        return false;
       }
    }else{
      return false;
    }
  }

  function keyUsing(data, type) {
    let accessKey = "";
    // let numValueSelects = ["table1_filter","table1", "table2_filter","offer-min-filter","offer-max-filter"];
    if(typeof props.optionId !== "undefined" && typeof props.optionValue !== "undefined"){
      accessKey = type === "id" ? data[props.optionId] : data[props.optionValue];
    }else{
      // if (props.inputName == "team-filter") {
      //   // console.log("team select uses team values");
      //   accessKey = type === "id" ? data.team_id : data.team;
      // }else if (props.inputName == "agent-filter") {
      //   // console.log("agent select uses agent values");
      //   accessKey = type === "id" ? data.agent_id : data.agent;
      // }else if (props.inputName == "suburb-filter") {
      //   // console.log("agent select uses agent values");
      //   accessKey = type === "id" ? data[1] : data[1];
      // }else if (props.inputName == "beds-filter") {
      //   // console.log("agent select uses agent values");
      //   accessKey = type === "id" ? data.name : data.name;
      // }else 
      if (props.inputName == "allocate-all-filter" || props.inputName == "allocate-agent" ) {
        // console.log("agent select uses agent values");
        accessKey = type === "id" ? data.agent_id + "-" + data.agent : data.agent;
      // }else if (numValueSelects.includes(props.inputName)) {
      //   // console.log("agent select uses agent values");
      //   accessKey = type === "id" ? data.numValue : data.name;
      // }else if (props.inputName == "suburb-filter-orphan") {
      //   // console.log("agent select uses agent values");
      //   accessKey = type === "id" ? data.s_name : data.s_name;
      // }
      }else{
        accessKey = type === "id" ? data.id : data.name;
      }
    }
    return accessKey;
  }

  function extraTxt(){
    if(props.inputName == "beds-filter"){
      return " Beds"
    }else{
      return "";
    }
  }

  function confirmOptionSelectable(){
    let matches = props.data.filter((f)=> Number(props.optionSelectedOnLoad) === Number(keyUsing(f,"id"))).length;
    let matchFound = matches > 0 ? true : false;
    return matchFound;
  }

  function selectValidate(d){
    if(confirmOptionSelectable()){
      if(typeof props.currentActive !== "undefined"){
       return Number(props.currentActive) === Number(keyUsing(d,"id"))
      }else{
        return Number(props.optionSelectedOnLoad) === Number(keyUsing(d,"id"))
      }
    }else{
      return false;
    }
  }

  function useOldDesign(input){
    const inputOverrideToOld = ["financial-year-select", "offer-min-filter", "offer-max-filter", ""]; //"office_filter_forecast"
    
    return inputOverrideToOld.includes(input) || input.includes("-agent-select");
  }

  return (
    <>
    {oldDesign || useOldDesign(props.inputName) ?
      <div className={props.classes !== "" ? "toggle-control-component "+props.classes :"toggle-control-component"}>
        <select
          name={props.inputName}
          id={typeof props.id !== "undefined" ? props.id : props.inputName}
          title={props.desc}
          onChange={(event) => handleChange(event)}
          disabled={disableIfUsersAccessNotAllowed() || props.disabled}
        >
          <option
            className=""
            value={props.defaultValue}
            selected={!confirmOptionSelectable()}
            hidden={props.defaultSelectable ? false : true}
            disabled={props.defaultSelectable ? false : true}
          >
            {props.defaultTxt}
          </option>
          {props.data.length > 0 ? props.data.map((x, index) => (
            <option key={index} value={keyUsing(x,"id")} selected={selectValidate(x) ? true : false}>
              {keyUsing(x,"optionTxt")+extraTxt()}
            </option>
          )):
          <option>
            {props.defaultTxt === "Item" ? "No "+props.defaultTxt+" data" : "No data"}
          </option>
          }
        </select>
        <span className="material-symbols-outlined">arrow_drop_down</span>
      </div>
      :
      <React_select 
      data={props.data}
          id={props.id}
          inputName={props.inputName}
          title={props.desc}
          defaultId = {props.defaultValue}
          defaultVal={props.defaultTxt}
          selectOnLoadOption={props.optionSelectedOnLoad}
          defaultSelectable={props.defaultSelectable}
          updateMethod={props.updateSelectChange}
          overRideSelectedValue = {typeof props.overRideSelectedValue !== "undefined" ? props.overRideSelectedValue : null}
          optionId={props.optionId}
          optionValue={props.optionValue}
          searchable={typeof props.searchable !== "undefined" ? props.searchable : false}
          disabled={typeof props.disabled !== "undefined" ? props.disabled : disableIfUsersAccessNotAllowed()}
          classes= {props.classes}
          isMulti={typeof props.isMulti !== "undefined" ? props.isMulti : false}
          />
    }
    </>
  );
}

export default Select_Input;
